import MISSION_ROLE_STATES from "constants/missionRoleStates";

/**
 * Sections of the Talent Simple role board, in render order.
 *
 * `states` are the MissionRoleFilter `states` values the section queries. Open covers both
 * published and unpublished, which the singular `state` filter cannot express.
 */
const TALENT_SIMPLE_ROLE_SECTIONS = [
  {
    key: "drafts",
    titleId: "Missions.Roles.TalentSimple.DraftsTitle",
    emptyId: "Missions.Roles.TalentSimple.DraftsEmpty",
    states: [MISSION_ROLE_STATES.draftInProgress],
    showAdvancedOptions: false,
    mergesAIRequests: true,
  },
  {
    key: "open",
    titleId: "Missions.Roles.TalentSimple.OpenTitle",
    emptyId: "Missions.Roles.TalentSimple.OpenEmpty",
    states: [MISSION_ROLE_STATES.published, MISSION_ROLE_STATES.unpublished, MISSION_ROLE_STATES.unpublishedNew],
    showAdvancedOptions: true,
  },
  {
    key: "closed",
    titleId: "Missions.Roles.TalentSimple.ClosedTitle",
    emptyId: "Missions.Roles.TalentSimple.ClosedEmpty",
    states: [MISSION_ROLE_STATES.closed],
    showAdvancedOptions: false,
  },
];

const TALENT_SIMPLE_ROLES_CONFIG = {
  RESULTS_PER_PAGE: 10,
};

export { TALENT_SIMPLE_ROLES_CONFIG };

export default TALENT_SIMPLE_ROLE_SECTIONS;
